<template>
  <div class="step step--humidity-opening humidity-opening humidity">
    <div class="humidity-opening__title text-shadow" v-html="$t('humidity.title')"></div>
    <div class="humidity-opening__text" v-html="$t('humidity.title2')"></div>

    <div class="conditioning__controls humidity-opening__controls">
      <div class="conditioning__image humidity-opening__image">
        <img src="@/assets/img/humidity-ac.png" alt="stylish condition">
      </div>

      <div class="conditioning__control humidity-opening__control">
        <img class="image-rendering-contrast" src="@/assets/img/modes/humidity.png" alt="humidity mode">
      </div>
    </div>

    <Button classes="button--small" @click="next()" v-html="$t('humidity.button')"></Button>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import Button from '@/components/global/Button'

export default {
  name: 'StepHumidity',
  props: {},

  components: {
    Button
  },

  data() {
    return {

    }
  },

  mounted () {
    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  created () {},

  updated () {},

  methods: {
    next() {
      if(this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-next',
          'analytics_label': this.$store.state.step,
        })
      }

      this.$emit('next')
    }
  },

  watch: {},

  computed: {
    ...mapState({
      step: state => state.step
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
